/* eslint-disable prefer-promise-reject-errors */
import { ParseObjVO, ParseStringVO } from "@utils/types/utils";
import { message } from "antd";
import dayjs from "dayjs";
import gcoord from 'gcoord';

/**
 * @param time string 或者 number 字符串
 * @return 返回一个参数对象
 * */
export const formatTime = (time: string | number) => {
  return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
};

/**
 * @param uri string url 字符串
 * @return 返回一个参数对象
 * */
export const parseUrl: ParseStringVO = (uri: string) => {
  if (!uri||!uri.includes("?")||!uri.split("?")[1]) {
    message.warning("未传入url").then();
    return null;
  }

  const urlKey: string = uri.split("?")[1];
  const urlObj: any = {};

  if (urlKey && urlKey.indexOf("&") !== -1) {
    const keyVal = urlKey.split("&");
    keyVal.forEach((_item) => {
      const arr = _item.split("=");
      const [key, val] = arr;
      urlObj[key] = val;
    });
  }
  if (urlKey&&urlKey.indexOf("&") === -1) {
    const [key, value] = urlKey.split("=");
    urlObj[key] = value
  }
  return urlObj;
};

/**
 * @param obj 对象结构
 * @return str url结构数据
 * @description 将一个对象转成url的结构
 * */
export const parseObj: ParseObjVO = (obj) => {
  let url;
  const keys: string[] = Object.keys(obj);
  url = [...keys, keys[0]].reduce((a, b) => `${b}=${obj[b]}&${a}`);
  url = `?${url}`;
  return url.slice(0, url.length - keys[0].length - 1);
};

/**
 * @param arg 参数
 * @description console.log的封装
 * */
export const logInfo = (...arg: any[]) => {
  // eslint-disable-next-line no-console
  console.log.call(null, ...arg);
};

/**
 * @param fn 将要执行的函数
 * @param delay 延迟时间
 * @description 防抖函数
 * */
export const debounce = (fn: any, delay: number) => {
  let timer: any;
  return (...args: any[]) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn(...args);
    }, delay);
  };
};

/**
 * @param fn 将要执行的函数
 * @param delay 延迟时间
 * @description 节流函数: 一段时间内执行触发函数，手动重置结束时间
 * */
export const throttle = (fn: any, delay: number) => {
  let timer: any;
  return (...args: any[]) => {
    if (timer) return;
    timer = setTimeout(() => {
      fn(...args);
      timer = null;
    }, delay);
  };
};

export const getLocation = () => {
  return new Promise((resolve, reject)=>{
    console.log(isWexin())
    if (isWexin()) {
      (window as any).wx.ready(()=>{
        (window as any).wx.getLocation({
          type: 'gcj02',
          isHighAccuracy: true,
          success: (res: any) => {
            console.log(res,'wx location')
            const {latitude, longitude} = res; // 纬度，浮点数，范围为90 ~ -90
            resolve({latitude, longitude})
          },
          fail: (error: any) => {
            reject(error)
          }
        })
      })
    } else if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((ev)=>{
        const [longitude, latitude] = gcoord.transform(
          [ev.coords.longitude, ev.coords.latitude],    // 经纬度坐标
          gcoord.WGS84,               // 当前坐标系
          gcoord.GCJ02                // 目标坐标系
        );
        resolve({latitude, longitude})
      }, (err)=> {
        reject(err)
      }, {
        // 指示浏览器获取高精度的位置，默认为false
        enableHighAccuracy: true,
        // 指定获取地理位置的超时时间，默认不限时，单位为毫秒
        timeout: 5000
      });
    } else {
      reject('no navigator')
    }
  })
};

export const isWexin = () => {
  const ua: any = window.navigator.userAgent.toLowerCase();
  return ua.indexOf('micromessenger') !== -1 && ua.indexOf('wxwork')===-1;
};

export const isWexinMini = () => {
  const ua: any = window.navigator.userAgent.toLowerCase();
  return ua.indexOf('miniprogram') !== -1 && ua.indexOf('wxwork')===-1;
};

export const numberFilter = (value: any) => {
  let format: any = value
  if (format && typeof(format)==='number') {
    console.log('dd');
    const str = `${format}`
    const arr = str.split(".")
    const len = Math.ceil(arr[0].length/3)
    let mol = (arr[0].length%3)
    mol = (mol===0?3:mol)
    let str_ = ''
    for (let i = 0;i<len;i+=1){
      if (i===0) {
        str_+=arr[0].substr(0,mol)
      } else {
        str_+=`,${arr[0].substr((i-1)*3+mol,3)}`
      }
    }
    if (arr[1]) {
      str_ += `.${arr[1]}`
    }
    format = str_
  } else {
    format = ''
  }
  return format
};